var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.498 14.286a.75.75 0 1 0-.996 1.12zm5.04 5.483-.498.56a.75.75 0 0 0 1.11-.126zM20.612 5.434a.75.75 0 0 0-1.224-.868zm-17.11 9.973L9.04 20.33l.997-1.121-5.539-4.923-.996 1.12zm6.648 4.796 10.462-14.77-1.224-.867-10.462 14.77z"
})));
export default SvgCheckmark;